module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_8023.f1b1e52f.png";